import { PartyPopper } from "lucide-react";
import { span } from "@/components/home/calculator/calc";

const Stat = ({ label, value, testId, big }) => (
  <div className={`rounded-2xl p-4 ${big ? "bg-[#0A1F13] text-white sm:col-span-2" : "bg-secondary"}`} data-testid={testId}>
    <p className={`text-xs font-bold uppercase tracking-widest ${big ? "text-amber-300" : "text-muted-foreground"}`}>{label}</p>
    <p className={`mt-1 font-display font-extrabold ${big ? "text-3xl sm:text-4xl" : "text-xl"}`}>{value}</p>
  </div>
);

export const CalcResults = ({ r, tierName }) => (
  <div className="grid gap-3 sm:grid-cols-2 content-start">
    <Stat label="Your price through us / lb" value={span(r, "ourPrice")} testId="calculator-our-price" />
    <Stat label="Savings / lb" value={span(r, "perLb")} testId="calculator-save-per-lb" />
    <Stat label="Total paying now" value={span(r, "totalNow")} testId="calculator-total-now" />
    <Stat label="Total through I'm The Plug Now" value={span(r, "totalUs")} testId="calculator-total-us" />
    <Stat label="Total savings" value={span(r, "savings")} testId="calculator-total-savings" big />
    <Stat label={`Net savings after ${tierName} membership`} value={span(r, "net")} testId="calculator-net-savings" />
    <div className="rounded-2xl p-4 border-2 border-primary/40 bg-primary/10 flex items-center gap-3" data-testid="calculator-break-even">
      <PartyPopper className="h-5 w-5 text-primary shrink-0" />
      <p className="text-sm font-bold">Your membership pays for itself after {span(r, "breakEven", (n) => n.toLocaleString("en-US"))} lbs</p>
    </div>
  </div>
);
